import CandiceFranck from "../../../../images/content/introduction/applia-secretariat/CandiceFranck.webp";
import PaoloFalcioni from "../../../../images/content/introduction/applia-secretariat/PaoloFalcioni.webp";

export const AppliaSecretariatMembersTeam1 = [
	{
		name: "Paolo Falcioni",
		imageUrl: PaoloFalcioni,
		background: "pages.introduction.appliaSecretariat.members.paoloFalcioni.background",
		functionTitle: "pages.introduction.appliaSecretariat.members.paoloFalcioni.functionTitle",
	},
	{
		name: "Candice Franck",
		imageUrl: CandiceFranck,
		background: "pages.introduction.appliaSecretariat.members.candiceFranck.background",
		functionTitle: "pages.introduction.appliaSecretariat.members.candiceFranck.functionTitle",
	},
];
